import { useContext, useEffect, useState } from 'react';
import GridProvider from './components/GridProvider';
import Inputs from './components/Inputs';
import useHttp from '../../../hooks/use-http';
import { TabContext } from '../../../Context/TabContext';
import Spinner from '../../UI/Modal/Spinner';
import toast from 'react-hot-toast';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { useTranslation } from 'react-i18next';
import { urls } from './api/urls';
import MyButton from '../../UI/myButton/MyButton';

const initialValues = {
  id: 0,
  idKupca: 0, // Početna vrednost može biti 0 ili null u zavisnosti od vaših potreba
  nazivKupca: '',
  naziv: '',
  adresa: '',
  kontaktOsoba: '',
  kontaktTelefon: '',
  idKorProm: 0, // Početna vrednost može biti 0 ili null u zavisnosti od vaših potreba
};
const Lokacije = ({
  save,
  handleSave,
  novi,
  handleNovi,
  idKlijenta = null,
}) => {
  const { t, i18n } = useTranslation();
  const idFirme = idKlijenta !== null ? idKlijenta : +localStorage.idFirme;
  const { sendRequest, data, isLoading } = useHttp('');
  // const { sendRequest: vratiKupce, data: kupciData } = useHttp('');
  const { getData } = useHttp('');
  const [formData, setFormData] = useState(initialValues);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);

  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localFormData = dataLocal?.formData ? dataLocal?.formData : {};

  useEffect(() => {
    if (Object.keys(localFormData).length > 0) {
      setFormData({
        ...formData,
        adresa: localFormData.adresa,
      });
    }
  }, []);

  const handleNoviUnos = () => {
    setFormData(initialValues);
  };

  useEffect(() => {
    if (novi) {
      handleNoviUnos();
      handleNovi(false);
    }
  }, [novi]);

  const fetchData = () => {
    const config = {
      method: 'POST',
      url: urls.GET_LOKACIJE,
      data: { id: idFirme },
    };
    sendRequest(config);
  };
  // const fetchKupciData = () => {
  //   const config = {
  //     url: urls.GET_KUPCE,
  //   };
  //   vratiKupce(config);
  // };
  useEffect(() => {
    fetchData();
    // fetchKupciData();
  }, []);

  useEffect(() => {
    const tab = {
      type: 69,
      title: 'Lokacije',
      icon: 'fas fa-map-marker-alt',
      formData: formData,
    };
    onTabChange(tab);
  }, [formData]);

  const handleSaveData = async () => {
    const url = formData.id === 0 ? urls.INSERT_LOKACIJE : urls.UPDATE_LOKACIJE;
    const config = {
      url,
      method: 'POST',
      data: {
        ...formData,
        idKupca: idFirme,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const response = await getData(config);

    if (response.id > 0) {
      toast.success(
        formData.id === 0
          ? t('messages.locationSavedSuccessfully')
          : t('messages.locationUpdatedSuccessfully'),
      );
      fetchData();
      setFormData(initialValues);
    } else {
      toast.error(t('messages.errorSavingData'));
    }
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);
  const handleEditData = (item) => {
    setFormData({
      id: item.id,
      idKupca: item.idKupca,
      nazivKupca: item.nazivKupca,
      naziv: item.naziv,
      adresa: item.adresa,
      kontaktOsoba: item.kontaktOsoba,
      kontaktTelefon: item.kontaktTelefon,
    });
  };

  const handleOpenDeleteDialog = (id) => {
    setFormData({ ...formData, id: id });
    setOpenDeleteDialog(true);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_LOKACIJE,
      data: { id: formData.id },
    };
    const result = await getData(config);

    if (result > 0) {
      fetchData();
      toast.success(t('messages.dataSuccessfullyDeleted'));
      setOpenDeleteDialog(false);
      setFormData(initialValues);
      return;
    }
    toast.error(t('messages.errorDeletingData'));
  };

  return (
    <div>
      {isLoading && <Spinner />}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <Inputs
          formData={formData}
          setFormData={setFormData}
          // korisniciData={kupciData}
        />
        {idKlijenta && (
          <div>
            <MyButton
              label={t('buttons.saveLocation')}
              onClick={handleSaveData}
            />
            <MyButton
              label={t('buttons.newLocation')}
              onClick={handleNoviUnos}
            />
          </div>
        )}
      </div>

      <GridProvider
        data={data}
        handleOpenDialog={handleOpenDeleteDialog}
        getEditData={handleEditData}
        isLoading={isLoading}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Lokacije;
